import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAssessQuestion, IQuestion } from '.';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { ApiPaths, UserApiPaths } from '../../dataProvider/APIPaths';

interface IGetAssessQuestions {
  content: string;
  difficulty: string;
}
interface IAIMarking {
  questionId: string;
  marking: string;
}

interface IGetAIMarking {
  questionId: string;
  answer?: string;
}

const QuestionApiDataProvider = new APIDataProvider<IQuestion[]>();
const AssessQuestionApiDataProvider = new APIDataProvider<IAssessQuestion[]>();
const AIMarkingApiDataProvider = new APIDataProvider<IAIMarking>();

export const getQuestionsBySubTopic = createAsyncThunk(
  'questions/subTopic',
  async (subTopic: string) => {
    const response = await QuestionApiDataProvider.getById(
      `${ApiPaths.questions}/${subTopic}`
    );

    return response.data;
  }
);

export const getRandomQuestionsBySubTopic = createAsyncThunk(
  'questions/random/subTopic',
  async (subTopic: string) => {
    const response = await QuestionApiDataProvider.getById(
      `${UserApiPaths.questions}/random/${subTopic}`
    );

    return response.data;
  }
);

export const getAssessQuestions = createAsyncThunk(
  'questions/assessQuestions',
  async (data: IGetAssessQuestions) => {
    const response = await AssessQuestionApiDataProvider.create(
      `${ApiPaths.questions}/getAssessQuestions`,
      data
    );

    return response.data;
  }
);

export const getAIMarking = createAsyncThunk(
  'questions/aiMarking',
  async (data: IGetAIMarking) => {
    const response = await AIMarkingApiDataProvider.create(
      `${ApiPaths.questions}/aiMarking`,
      data
    );
    return response.data;
  }
);
